import React, { useState } from "react";
import { motion } from "framer-motion";
import logoImg from "../assets/logo.png";

const Header = () => {
  const [logoError, setLogoError] = useState(false);

  return (
    <header className="bg-white/80 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          
          {/* Logo + Title Section */}
          <div className="flex items-center space-x-4">
            <motion.div
              whileHover={{ scale: 1.05, rotate: 5 }}
              whileTap={{ scale: 0.95 }}
              className="relative w-12 h-12 flex items-center justify-center rounded-2xl overflow-hidden shadow-lg shadow-emerald-100 bg-emerald-50"
            >
              {!logoError ? (
                <img
                  src={logoImg}
                  alt="NutriScan Logo"
                  className="w-full h-full object-cover"
                  onError={() => setLogoError(true)}
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-emerald-600 font-black text-lg">
                  F
                </div>
              )}
            </motion.div>

            <div className="flex flex-col">
              <h1 className="text-xl font-black tracking-tight text-gray-900 leading-none">
                Fitness <span className="text-emerald-500 italic">Tracker</span>
              </h1>
              <span className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 mt-1">
                AI-Powered Fitness
              </span>
            </div>
          </div>

        </div>
      </div>
    </header>
  );
};

export default Header;
